import * as ActionTypes from './actionTypes';
import get from 'lodash/get';

// -----------------------------------------------------
// Default State for Clients Tab as per new UX Design
// -----------------------------------------------------

const initialState = {
  bob: {
    renewals: {
      summary: {},
      sortByValue: '-renewalDate',
      filters: null,
      filtersQueryString: '',
      searchDetails: {
        searchBy: 'clientName',
        value: '',
        isLoading: false,
        options: [],
      },
      pageNumber: 1,
      isLoading: false,
      isServiceError: false,
    },
  },
  rowSummary: {},
  renewalsDashboard: {},
  renewalsDashboardLoading: true,
  renewalsDashboardError: false,
  autoSuggestResults: [],
  documentsChecklist: [],
  documentBeingLoaded: [],
  digitalSelectionEnabledForUpsellFlow: false,
  isSubscriberLevelForUpsellFlow: false
};

export default function renewalsSummaryReducer(state = initialState, action) {
  const defaultBOB = initialState.bob;
  const defaultRenewals = defaultBOB.renewals;
  const defaultSearchDetails = defaultRenewals.searchDetails;
  const defaultSummary = defaultRenewals.summary;
  switch (action.type) {
    case ActionTypes.RENEWALS_PDF_FETCH_FAILED:
    case ActionTypes.RENEWALS_PDF_NOT_FOUND:
    case ActionTypes.RENEWALS_ALTERNATE_QUOTE_PDF_FETCH_FAILED:
    case ActionTypes.RENEWALS_ALTERNATE_QUOTE_PDF_NOT_FOUND:
    case ActionTypes.UPSELL_RENEWALS_USE_QUOTE_FAILED:
    case ActionTypes.QUICK_RENEWALS_APP_CREATION_FAILED:
    case ActionTypes.ARVATO_SUMMARY_FAILED:
    case ActionTypes.ARVATO_SUMMARY:
      return { ...state, ...action.payload };

    case ActionTypes.RENEWALS_SUMMARY_DASHBOARD:
      return { ...state, ...action.payload, renewalsDashboard: action.payload.renewalsDashboard };

    case ActionTypes.RENEWALS_SUMMARY_DASHBOARD_FETCH_FAILED:
      return { ...state, ...action.payload };

    case ActionTypes.CLICKED_ROW_SUMMARY:
      return { ...state, rowSummary: action.payload.rowSummary };

    case ActionTypes.AUTO_SUGGEST_SEARCH_SUCCESS:
    case ActionTypes.AUTO_SUGGEST_SEARCH_FAILED:
      return { ...state, autoSuggestResults: action.payload.autoSuggestResults };

    case ActionTypes.RENEWALS_SERVICE_ERROR:
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
          renewals: { ...get(state.bob, 'renewals', defaultRenewals), isLoading: false, isServiceError: true },
        },
      };

    case ActionTypes.REQUEST_RENEWALS_DATA:
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
          renewals: { ...get(state.bob, 'renewals', defaultRenewals), isLoading: true, isServiceError: false },
        },
      };

    case ActionTypes.SET_FILTER_QUERY_STRING:{
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
         renewals: {
          ...get(state.bob, 'renewals', defaultRenewals),
          filtersQueryString: action.payload.filtersQueryString,
          filters: action.payload.filters
         }
        }
      }
    }  

    case ActionTypes.RECEIVE_RENEWALS_DATA:
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
          renewals: {
            ...get(state.bob, 'renewals', defaultRenewals),
            isLoading: false,
            isServiceError: false,
            summary: action.response,
          },
        },
      };

    case ActionTypes.RENEWALS_SET_PAGE_NUMBER:
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
          renewals: {
            ...get(state.bob, 'renewals', defaultRenewals),
            pageNumber: action.pageNumber,
          },
        },
      };

    case ActionTypes.CONCAT_RENEWALS_DATA:
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
          renewals: {
            ...get(state.bob, 'renewals', defaultRenewals),
            isLoading: false,
            isServiceError: false,
            summary: {
              ...action.response,
              data: [...get(state.bob, 'renewals.summary.data', []), ...action.response.data],
            },
            pageNumber: action.pageNumber,
          },
        },
      };

    case ActionTypes.SET_RENEWALS_SEARCH_DETAILS:
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
          renewals: {
            ...get(state.bob, 'renewals', defaultRenewals),
            searchDetails: {
              ...get(state.bob, 'renewals.searchDetails', defaultSearchDetails),
              ...action.details,
            },
          },
        },
      };

    case ActionTypes.SET_RENEWALS_REST_PROPS:
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
          renewals: { ...get(state.bob, 'renewals', defaultRenewals), ...action.details },
        },
      };

    case ActionTypes.SET_UPLOAD_DOCUMENTS:
      return {
        ...state,
        documentsChecklist: action.payload,
      };

    case ActionTypes.UPSELL_RENEWALS_USE_QUOTE_SUCCESS:
      return {
        ...state,
        bob: {
          ...get(state.bob, defaultBOB),
          renewals: {
            ...get(state.bob, 'renewals', defaultRenewals),
            summary: {
              ...get(state.bob, 'renewals.summary', defaultSummary),
              data: state.bob.renewals.summary.data.map(renewalSummary => {
                if (renewalSummary.clientID === action.payload.clientID) {
                  return {
                    ...renewalSummary,
                    appID: action.payload.appID,
                  };
                } else {
                  return {
                    ...renewalSummary,
                  };
                }
              }),
            },
          },
        },
      };
    case ActionTypes.QUICK_RENEWALS_APP_CREATION_SUCCESS:
      return {
        ...state,
        rowSummary: {
          ...state.rowSummary,
          appID: action.payload.appID,
          applicationType: action.payload.applicationType,
        },
      };
    case ActionTypes.DOC_LOADING:
      return {
        ...state,
        documentBeingLoaded: {
          docName: action.payload.docName,
          loading: true,
        },
      };
    case ActionTypes.DOC_LOADING_DONE:
      return {
        ...state,
        documentBeingLoaded: {
          docName: action.payload.docName,
          loading: false,
        },
      };
    case ActionTypes.DOC_LOADING_ERR:
      return {
        ...state,
        documentBeingLoaded: {
          loading: false,
          error: true,
        },
      };

    case ActionTypes.DIGITAL_SEL_DONE:
      return {
        ...state,
        digitalSelectionEnabledForUpsellFlow: action.payload.digitalSelectionEnabled,
        isSubscriberLevelForUpsellFlow: action.payload.isSubscriberLevelForUpsellFlow
      };
    case ActionTypes.DIGITAL_SEL_ERR:
      return {
        ...state,
        digitalSelectionEnabledForUpsellFlow: false
      };
    
    case ActionTypes.DISABLE_SUBSCRIBER_LEVEL_UPSELL_FLAG:
    return {
      ...state,
      digitalSelectionEnabledForUpsellFlow: action.payload.value,
      isSubscriberLevelForUpsellFlow: action.payload.value
    };

    case ActionTypes.RESET_RENEWALS_SUMMARY: 
    return {
      bob: {
        renewals: {}
      }
    };

    default:
      return state;
  }
}
